import React, { useEffect } from 'react';
import PageTitle from 'ui/views/layouts/BaseLayout/PageTitle';
import MaxWidth, { maxWidths } from 'ui/views/containers/MaxWidth';
import styled from '@emotion/styled';
import { bluePlanetTheme } from 'ui/theme';
import { contentSpacing, halfSpacing, sectionSpacing } from 'ui/theme/themeConstants';
import { css } from '@emotion/react';
import { useMobileHeader } from 'domain/shared/Navigation';
import ScrollableBody from '../BaseLayout/ScrollableBody';
import { scrollToTop } from 'util/scroll';
import { CommunityConfiguration, TinyCommunity } from 'types/company/community';
import CommunityHeader from './CommunityHeader';

export const communityBleedAmounts = {
  xs: halfSpacing, // Same as <MobileMargin>
  sm: contentSpacing,
  md: sectionSpacing,
  lg: sectionSpacing,
};

const horizontalSpacing = css`
  margin: 0 auto;
  max-width: ${maxWidths.xl};
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  ${bluePlanetTheme.breakpoints.up('sm')} {
    padding-left: ${contentSpacing};
    padding-right: ${contentSpacing};
  }
  ${bluePlanetTheme.breakpoints.up('md')} {
    padding-left: ${sectionSpacing};
    padding-right: ${sectionSpacing};
  }
`;

export const HorizontalSpacing = styled.div`
  ${horizontalSpacing}
`;

export const Main = styled.main<{ fillHeight?: boolean }>`
  ${horizontalSpacing}
  padding-top: ${contentSpacing};
  padding-bottom: ${contentSpacing};

  ${props =>
    props.fillHeight
      ? `
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding-top: 0;
    padding-bottom: 0;
  `
      : ''}
`;

export default function CommunityPage({
  title,
  backHref,
  subheading,
  community,
  configuration,
  children,
  mobileHeaderTitle,
  disableSearch,
  imageURL,
  fillHeight,
}: {
  community: TinyCommunity;
  configuration: CommunityConfiguration;
  title: string;
  mobileHeaderTitle?: string;
  subheading?: React.ReactNode;
  children?: React.ReactNode;
  backHref?: string;
  disableSearch?: boolean;
  imageURL?: string;
  /** Hand the viewport height to the content so it can own its own scroll (see ScrollableBody). */
  fillHeight?: boolean;
}) {
  useEffect(() => {
    scrollToTop();
  }, []);

  useMobileHeader(mobileHeaderTitle ?? title);
  return (
    <>
      <PageTitle title={title} />
      <ScrollableBody accountForMobileHeader fillHeight={fillHeight}>
        <div
          className="u-flex-center"
          style={{ backgroundColor: bluePlanetTheme.bluePlanetPalette.white, flexShrink: 0 }}
        >
          <MaxWidth width="xl">
            <CommunityHeader
              backHref={backHref}
              subheading={subheading}
              community={community}
              configuration={configuration}
              disableSearch={disableSearch}
              imageURL={imageURL}
            />
          </MaxWidth>
        </div>
        {children}
      </ScrollableBody>
    </>
  );
}
